import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCreateOffer } from "./createSpecialOffer.request";
import { CreateOfferResponse } from "./createSpecialOffer.types";

const useCreateSpecialOffer = (
  options?: MutationOptions<CreateOfferResponse, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateOffer,
    ...options
  });
};

export default useCreateSpecialOffer;
